<template lang="pug">
  div
    div(v-if="comment.payload.replied_comment_id === 0"
      class="reply-wrapper"
      :class="{'reply-wrapper--me': isMe}")
      comment-render(text="Message has been deleted")

    div(v-if="comment.payload.replied_comment_id !== 0"
      class="reply-wrapper"
      :class="{'reply-wrapper--me': isMe }"
      @click="clickHandler")
      div(class="reply-sender") {{ comment.payload.replied_comment_sender_username }}
      div(class="reply-caption-container" v-if="isAttachment")
        comment-render(v-if="isAttachment && attachmentHasCaption"
          :text="comment.payload.replied_comment_payload.caption")
        image-loader(v-if="isAttachment"
          :comment="comment"
          :message="comment.payload.replied_comment_message"
          :thumbnailMode="true"
          :on-click-image="onClickImage"
          :callback="callback")
      comment-render(v-if="!isAttachment"
        :text="repliedText")

    image-loader(v-if="comment.isAttachment(comment.payload.text)"
      :comment="comment"
      :message="comment.payload.text"
      :thumbnailMode="true"
      :on-click-image="onClickImage"
      :callback="callback")

    comment-render(v-if="!comment.isAttachment(comment.payload.text) && !isInteractiveMessage"
      :text="comment.payload.text")
    div(v-if="!isAttachment && isInteractiveMessage")
      div(v-if="isInteractiveMessageHeader"
        v-html="isInteractiveMessageHeader"
        :class="comment.extras.interactive.type === 'list_reply' ? 'qcw-interactive__header' : 'qcw-interactive__body'")
      div(v-if="isInteractiveMessageDesc" v-html="isInteractiveMessageDesc" class="qcw-interactive__body")
</template>

<script>
import ImageLoader from './ImageLoader';
import CommentRender from './CommentRender';

export default {
  name: 'CommentReply',
  components: { ImageLoader, CommentRender },
  props: ['comment', 'isMe', 'clickHandler', 'onClickImage', 'callback'],
  computed: {
    isAttachment() {
      return this.comment.isAttachment(
        this.comment.payload.replied_comment_message,
      );
    },
    attachmentHasCaption() {
      return (
        this.comment.payload.replied_comment_payload.caption != null &&
        !this.comment.payload.replied_comment_payload.caption.includes(
          'This message was sent on previous session by',
        )
      );
    },
    repliedText() {
      const isTrue = this.comment.payload.replied_comment_message.includes(
        'This message was sent on previous session by',
      );
      let text = '';
      if (isTrue) {
        const lines = this.comment.payload.replied_comment_message
          .split('\n')
          .filter(l => l.trim() !== '');
        lines.forEach((line, index) => {
          if (index < lines.length - 2) {
            text = `${line.trim()}\n`;
          }
        });
      } else {
        text = this.comment.payload.replied_comment_message;
      }
      return text;
    },
    isInteractiveMessage() {
      const extras = this.comment.extras;
      if (!extras) return false;
      return (
        extras.interactive &&
        (extras.interactive.type === 'list_reply' ||
          extras.interactive.type === 'button_reply')
      );
    },
    isInteractiveMessageHeader() {
      if (!this.isInteractiveMessage) return '';
      const extras = this.comment.extras;
      if (
        extras.interactive.list_reply &&
        extras.interactive.list_reply.title
      ) {
        return extras.interactive.list_reply.title;
      } else if (
        extras.interactive.button_reply &&
        extras.interactive.button_reply.title
      ) {
        return extras.interactive.button_reply.title;
      }
      return '';
    },
    isInteractiveMessageDesc() {
      if (!this.isInteractiveMessage) return '';
      const extras = this.comment.extras;
      if (
        extras.interactive.list_reply &&
        extras.interactive.list_reply.description
      ) {
        return extras.interactive.list_reply.description;
      } else if (
        extras.interactive.button_reply &&
        extras.interactive.button_reply.description
      ) {
        return extras.interactive.button_reply.description;
      }
      return '';
    },
  },
};
</script>

<style lang="stylus" scoped>
.reply-wrapper .reply-caption-container {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/CommentReply.vue